import React from 'react';
import PropTypes from 'prop-types';
import { hasChildren } from '../../helpers';
const ContentGroupSection = ({
  children,
  name
}) => {
  if (!hasChildren(children)) return null;
  return /*#__PURE__*/React.createElement("div", {
    key: name,
    className: "content-group-section"
  }, children);
};
ContentGroupSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  name: PropTypes.string
};
ContentGroupSection.defaultProps = {
  children: null,
  name: ''
};
export default ContentGroupSection;
//# sourceMappingURL=ContentGroupSection.js.map